import { useNavigate } from "react-router-dom";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import ET3DataLink from "../../../../../core/et3-shared-components/DataLink";
import getCorePersonalStore from "../../../../../stores/core/core-personal-store";

const KhattabActions = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const navigate = useNavigate();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={1500}
      height={100}
      fDirection="row"
      alignItems="center"
      justifyContent="space-around"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3DataLink
        type={"button"}
        name={"USER_MESSAGES"}
        onPress={async () => {
          navigate({
            pathname: "/users/messages",
            search: `id=${userID}`
          });
          await getCorePersonalStore().insertAdminEvent({
            eventName: "GO_TO_MESSAGES",
            fromPage: "USER_ADVANCED",
            userID: userID,
            extraData: {}
          });
        }}
      />
      <ET3DataLink
        type={"button"}
        name={"USER_PAYMENTS"}
        onPress={async () => {
          navigate({
            pathname: "/users/payments",
            search: `id=${userID}`
          });
          await getCorePersonalStore().insertAdminEvent({
            eventName: "GO_TO_PAYMENTS",
            fromPage: "USER_ADVANCED",
            userID: userID,
            extraData: {}
          });
        }}
      />
      <ET3DataLink
        type={"button"}
        name={"USER_EVENTS"}
        onPress={async () => {
          navigate({
            pathname: "/users/events",
            search: `id=${userID}`
          });
          getUserAdvancedStore().goToUserEvents(userID);
          await getCorePersonalStore().insertAdminEvent({
            eventName: "GO_TO_EVENTS",
            fromPage: "USER_ADVANCED",
            userID: userID,
            extraData: {}
          });
        }}
      />
    </ET3Div>
  );
});

export default KhattabActions;
